import React, { useCallback } from "react";
import * as THREE from 'three';
import MLeg from '../marker/mLeg';
import MSocketLoad from '../marker/mSocketLoad';

import { Lines } from "../shape/Line";

import MMeasure from '../marker/mMeasure';
import MSoftInsert from '../marker/mSoftInsert';


import Control from '../store/control';
import Param from '../store/param';

// -----------------------------------------------
// （本義足/テストソケット）共通のマーカー制御を行う
// Paramへのアクセスはここに集約し、marker/ 配下では行わないこと！
// -----------------------------------------------

const MarkingCommon = () => {
  const activeStep         = Param.Get("activeStep");
  const setup              = Param.Get("setup");
  const softInsert         = Param.Get("softInsert");
  
  const prosthetics        = Control.Get('prosthetics');
  const showLeg            = Control.Get("showLeg");
  const showSocket         = Control.Get("showSocket");
  const wireLeg            = Control.Get("wireLeg");
  const transparentLeg     = Control.Get("transparentLeg");
  const wireSocket         = Control.Get("wireSocket");
  const meshLeg            = Control.Get("meshLeg");
  const meshSocketLoad         = Control.Get("meshSocketLoad");

  const flgLegClickable    = Control.Get("flgLegClickable");
  const flgSocketClickable = Control.Get("flgSocketClickable");
  const currentAngle       = Control.Get("currentAngle");
  const measure            = Control.Get('measure');

  console.log('marking common');
  console.log(activeStep);
  
  var opacityLeg = 0;
  const opacity = (showLeg) ? 0.8 : 0.8;
  (activeStep>=3)? opacityLeg = 0.4 : opacityLeg = 1;
  
  const isMeasure   = measure;
  const isLeg       = meshLeg && showLeg;
  const isSocket    = meshSocketLoad //&& showSocket;
  const isModeling  = (activeStep == 2);

  return (
    <>
      { isMeasure ? <MMeasure
                      angle = {currentAngle}
                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                      /> : null }

      { isLeg     ? <MLeg 
                      meshLeg={meshLeg} 
                      clickable={flgLegClickable} 
                      showWire={wireLeg}
                      showTransparent={transparentLeg}
                      opacityLeg={opacityLeg}
                      fileExt={0}
                    /> : null }

      { isSocket  ? <MSocketLoad
                      meshSocketLoad={meshSocketLoad}
                      clickable={flgLegClickable} 
                      showWire={wireLeg}
                      showTransparent={transparentLeg}
                      fileExt={0}
                      color={'dodgerblue'}
                    /> : null }

      { isModeling ? <MSoftInsert
                      meshLeg={meshLeg}
                      meshSocketLoad={meshSocketLoad}
                      prosthetics={prosthetics}
                      topLineHeight={softInsert.topLineHeight}
                      bottomLineHeight={softInsert.bottomLineHeight}
                      offsetToBottom={softInsert.offsetToBottom}
                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                      /> : null }
    </>
  );
};

export default MarkingCommon;
